import countries from '../components/form/CountrySelector/countries.json'

export const getFlagEmoji = name => {
  const country = countries.find(c => c.name === name)
  return country ? country.emoji : ''
}
